import { ELEVATION_TOKENS } from '../elevation/elevationTokens';
import type { ElevationTokenKey } from '../elevation/elevationTokens';
import { RADIUS_TOKENS } from '../shape/radiusTokens';
import type { RadiusTokenKey } from '../shape/radiusTokens';

export function surfacePaperStyles(opts: { radius: RadiusTokenKey; elevation: ElevationTokenKey }) {
  return {
    borderRadius: RADIUS_TOKENS[opts.radius],
    boxShadow: ELEVATION_TOKENS[opts.elevation],
  };
}
